import { render, staticRenderFns } from "./UndoRedoBtns.vue?vue&type=template&id=1cd2a22c&scoped=true&"
import script from "./UndoRedoBtns.vue?vue&type=script&lang=ts&"
export * from "./UndoRedoBtns.vue?vue&type=script&lang=ts&"
import style0 from "./UndoRedoBtns.vue?vue&type=style&index=0&id=1cd2a22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2a22c",
  null
  
)

export default component.exports